export default function VideoCardSkeleton() {
  return (
    <article className="card bg-base-100 shadow-sm overflow-hidden group">
      <div className="carousel bg-base-300 space-x-1 p-1">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="carousel-item w-2/5">
            <div className="skeleton w-full aspect-video"></div>
          </div>
        ))}
      </div>

      <div className="card-body p-3 gap-2">
        <div className="card-actions flex gap-2">
          <div className="skeleton h-8 flex-1"></div>
          <div className="skeleton h-8 w-8"></div>
        </div>
      </div>
    </article>
  );
}
